import { Check, ArrowUpRight } from "lucide-react";
import { Button } from "../ui/button";
import { scrollToBook } from "@/config/siteLinks";

const perks = [
  "Dedicated placement specialist",
  "Executive-level resume & LinkedIn positioning",
  "Direct introductions to responsive HRs",
  "90-day post-joining check-in",
];

export const Pricing = () => {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="bg-[#F0EFEB] py-24 sm:py-32 border-y border-[#1C1C1A]/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="grid grid-cols-12 gap-y-10 gap-x-8 items-end mb-16">
          <div className="col-span-12 md:col-span-7">
            <p className="label-eyebrow text-[#143628] mb-5">Pricing</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.05] tracking-tight">
              Built for <em className="italic text-[#143628]">experienced engineers.</em>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-5 text-[#4A4A48] text-lg leading-relaxed">
            We currently work with experienced engineers - mid and senior roles in AI, full-stack, and data.
            Pricing is bespoke and discussed openly on the consultation call.
          </p>
        </div>

        <div
          data-testid="pricing-tier-experienced"
          className="relative bg-[#143628] text-[#F9F9F7] border border-[#143628] shadow-[0_40px_80px_-40px_rgba(20,54,40,0.6)]"
        >
          <span className="absolute -top-3 left-8 bg-[#D4B886] text-[#143628] text-[10px] tracking-[0.2em] font-semibold uppercase px-3 py-1">
            Now accepting · Experienced tier
          </span>

          <div className="grid grid-cols-1 lg:grid-cols-12">
            {/* Left column - headline & value */}
            <div className="lg:col-span-7 p-8 sm:p-12 lg:p-14 border-b lg:border-b-0 lg:border-r border-[#F9F9F7]/15">
              <p className="label-eyebrow text-[#D4B886] mb-8">For experienced engineers</p>

              <p className="font-serif-display text-3xl sm:text-4xl lg:text-[44px] leading-[1.1] tracking-tight mb-8">
                Move up. Senior placements with founders, CTOs, and engineering heads.
              </p>

              <p className="text-[#F9F9F7]/75 leading-relaxed text-base sm:text-lg max-w-xl">
                A white-glove engagement built around your stage and the roles you&rsquo;re after.
              </p>

              <div className="mt-10 flex flex-col sm:flex-row gap-4">
                <Button
                  data-testid="pricing-tier-experienced-cta"
                  onClick={scrollToBook}
                  className="rounded-none bg-[#D4B886] text-[#143628] hover:bg-[#e3cca0] h-14 px-8 text-base font-medium tracking-tight group"
                >
                  Book a consultation
                  <ArrowUpRight className="ml-2 h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </Button>
                <a
                  href="#faq"
                  data-testid="pricing-secondary-faq"
                  className="inline-flex items-center justify-center gap-2 h-14 px-6 border border-[#F9F9F7]/30 text-[#F9F9F7] hover:bg-[#F9F9F7] hover:text-[#143628] transition-colors text-base"
                >
                  Read the FAQs
                </a>
              </div>
            </div>

            {/* Right column - perks */}
            <div className="lg:col-span-5 p-8 sm:p-12 lg:p-14">
              <p className="label-eyebrow text-[#D4B886] mb-6">What&rsquo;s included</p>
              <ul className="space-y-4">
                {perks.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-[15px]">
                    <Check className="h-4 w-4 mt-1 flex-shrink-0 text-[#D4B886]" />
                    <span className="text-[#F9F9F7]">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
